module.exports = __webpack_public_path__ + "static/media/s_visa.c6eb9f46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pay/s_visa.png
// module id = 2447
// module chunks = 7